export default "__VITE_ASSET__d9dfc914__"